
import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

const namespace: string = 'restaurant';

@Component<CalendarViewToggle>({})
export default class CalendarViewToggle extends Vue {
	@Action('setCalendarViewMode', { namespace }) private setCalendarViewMode!: (mode: CalendarViewMode) => Promise<void>;
	@Getter('getCalendarViewMode', { namespace }) private viewMode!: CalendarViewMode;
	@Getter('getDateRange', { namespace }) private dateRange!: DateRange;

	/**
	 * Switch the calendar view mode (no-op if already selected) and update the
	 * URL query param so the selected view/period survives a reload.
	 *
	 * @param {CalendarViewMode} mode
	 * @return {Promise<void>}
	 */
	private async select(mode: CalendarViewMode): Promise<void> {
		if (this.viewMode === mode) {
			return;
		}
		await this.setCalendarViewMode(mode);

		const query = { ...this.$route.query };
		const rangeStart = this.dateRange.start;
		if (mode === 'monthly') {
			delete query.selectedWeek;
			if (rangeStart) {
				query.selectedMonth = rangeStart;
			}
		}
		else {
			delete query.selectedMonth;
			if (rangeStart) {
				query.selectedWeek = rangeStart;
			}
		}
		this.$router.replace({ query }).catch(() => {});
	}
}
